import { PencilSimple } from "@phosphor-icons/react";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { buttonVariants } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { VideoForm } from "@/routes/video/components/VideoForm";
import { cn } from "@/utils";

export const CreateVideoRoute = () => {
    const navigate = useNavigate();

    const onClose = useCallback(() => {
        navigate(-1);
    }, [navigate]);

    return (
        <Dialog open onOpenChange={onClose}>
            <DialogTrigger className={cn(buttonVariants())}>
                <PencilSimple />
            </DialogTrigger>
            <DialogContent className="max-h-screen overflow-y-auto" aria-describedby={undefined}>
                <DialogHeader>
                    <div className="mr-4 flex items-center justify-between">
                        <DialogTitle>Create video</DialogTitle>
                    </div>
                </DialogHeader>
                <VideoForm onSubmitSuccess={onClose} />
            </DialogContent>
        </Dialog>
    );
};
